<template>
	
	<BarArrowButton :flex="true" :large="true" class="linkAccounts " title="Spending Analysis" href="/#/setupspendinganalysis" :bgImage="require('@/assets/bg/puzzle.png')">
		<div class="barArrowButtonSlotContent">
			<a href="/#/setupspendinganalysis">
			<p>You can set your pay cycle by clicking here to get the most out of Money Guided.</p>
			</a>
		</div>
	</BarArrowButton>
	
</template>

<script>
import BarArrowButton from './BarArrowButton.vue';

export default {
	name: "SetPayCycleShoutPanel",
	props: [],
	components: {
		BarArrowButton
	},
	data() {
		return{
			something: null
		}
	},
	methods: {
		onLoad() {
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

.barArrowButtonSlotContent {
	padding: 20px;
	padding-top: 12px;
	padding-bottom: 5px;
	p {
		margin-top: -5px;
		font-size: 13px;
	}
}


</style>